import { Button, Stack } from '@mui/material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

import MobileNumberInput from './components/MobileNumberInput';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import EnterVerificationCode from './components/EnterVerificationCode';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { GetLoginVerificationCode } from '../../Hooks/GetLoginVerificationCode';
import CircularDetermineProgress from './components/CircularDetermineProgress';
import useTimer from '../../Hooks/useTimer';
import { LoginWithMobile } from '../../Adapters/LoginWithMobile';

const LoginByMobileNumber = () => {
  const GlobalConstants = useContext(GlobalContext);
  const navigate = GlobalConstants.navigate;
  const [verificationTimer, setverificationTimer] =
    React.useState(false);
  const { control, formState, watch, reset } = useForm({
    defaultValues: {
      Mobile: '',
      VerificationCode: '',
    },
  });
  const watchAllFields = watch();
  const languageArray =
    useContext(GlobalContext)?.languageArray;

  const sendSMSLabel = FindLangKey(
    'login-btn-sent-sms-login'
  );

  const sendsms_alert = FindLangKey(
    'login-alert-send-sms-mobile-number'
  );

  // console.log(
  //   'verificationTimerverificationTimer==>',
  //   verificationTimer
  // );

  const Handle_sendSMS = () => {
    SwalAlert('warning', sendsms_alert, true, () => {
      GetLoginVerificationCode(
        watchAllFields.Mobile,
        reset,
        setverificationTimer
      );
    });
  };

  React.useEffect(() => {
    if (
      watchAllFields.Mobile ||
      watchAllFields.VerificationCode
    ) {
      if (
        watchAllFields.Mobile.length === 11 &&
        watchAllFields.VerificationCode.toString()
          .length === 0
      ) {
        if (!verificationTimer) {
          // GetLoginVerificationCode(watchAllFields.Mobile, reset);
          // setverificationTimer(true);
        }
      } else {
        if (
          watchAllFields.VerificationCode &&
          watchAllFields.VerificationCode.toString()
            .length === 5
        ) {
          LoginWithMobile(watchAllFields, navigate);
        }
      }
    }
  }, [
    watchAllFields.Mobile,
    watchAllFields.VerificationCode,
  ]);

  const timer = useTimer(
    verificationTimer,
    reset,
    setverificationTimer
  );

  // console.log('timer=>', timer);

  return (
    <form style={{ marginBlock: '1em' }}>
      {/* {watchAllFields.Mobile && watchAllFields.Mobile.length === 11 ? (
        <>
          <Stack justifyContent="center" alignItems="center" marginBottom="1em">
         
          </Stack>
          <EnterVerificationCode
            control={control}
            formState={formState}
            languageArray={languageArray}
          />
        </>
      ) : (
        <MobileNumberInput control={control} formState={formState} />
      )} */}

      <Stack gap=".5em">
        <MobileNumberInput
          control={control}
          formState={formState}
        />
        {verificationTimer ? (
          <Stack>
            <EnterVerificationCode
              control={control}
              formState={formState}
              languageArray={languageArray}
            />
            <CircularDetermineProgress timer={timer} />
          </Stack>
        ) : (
          <></>
        )}
        {watchAllFields.Mobile &&
        watchAllFields.Mobile.length === 11 ? (
          <Button
            variant="contained"
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
              maxHeight: '40px',
            }}
            onClick={Handle_sendSMS}
          >
            {sendSMSLabel}
          </Button>
        ) : (
          <></>
        )}
      </Stack>
    </form>
  );
};

export default LoginByMobileNumber;
